import React, { Component } from "react";
import Footerlogo from "../walkin/footerlogo.index";

export default class footerlogo extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Footerlogo/>
    );
  }
}
